import React from 'react';
import Copy from 'copy-to-clipboard';
import ABSMessage from '../../ABSMessage';
import RouteConfig from '../../../abs/config/routeConfig';
import InvitationCard from './InvitationCard';
import {
  defaultLinkContent,
  LinkInvitationHeaderImg,
  CopySuccessMessage
} from './util';
import authService from '../../../abs/services/auth/authService';
import ABSInput from '../../ABSInput';
import { isPass } from '../../../utils/Validator';

export interface ILinkInvitationProps {
  className?: string;
}

export interface ILinkInvitationState {}

const user = authService.getCurrentUser();
const url = `${window.location.origin}${RouteConfig.home}`;
const defaultUrl = `${url}?invitationId=${user ? user.id : ''}`;

class LinkInvitation extends React.Component<
  ILinkInvitationProps,
  ILinkInvitationState
> {
  private invitationField: ABSInput | null;

  renderInputContent() {
    const content = defaultLinkContent + defaultUrl;
    return (
      <ABSInput
        className="abs-invitation-content-input"
        height={180}
        type="textarea"
        defaultValue={content}
        ref={view => (this.invitationField = view)}
        required={true}
      />
    );
  }

  onCopy = () => {
    const validateResult = isPass(this.invitationField);
    if (!validateResult) {
      return;
    }
    const content = this.invitationField ? this.invitationField.getValue() : '';
    Copy(content);
    ABSMessage.success(CopySuccessMessage);
  };

  render() {
    const footBtn = {
      title: '复制链接',
      icon: 'binding',
      onClick: () => this.onCopy()
    };
    return (
      <InvitationCard
        headerImg={LinkInvitationHeaderImg}
        headerTitle="链接邀请"
        title="复制以下文字发送给好友，邀请他们来CNABS"
        content={this.renderInputContent()}
        footBtn={footBtn}
      />
    );
  }
}

export default LinkInvitation;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSHeader/ABSInvitation/LinkInvitation.tsx